import React, { useState, useEffect } from 'react';
import './styles.css';

import {useDispatch, useSelector} from "react-redux";
import {getAuthToken, getUserData} from "../../components/UserLogin/reducer";
import {MEETS_PAGE_COUNT, fetchMeets, fetchTimeMeets, fetchVenues} from "./actions";

// Компоненты
import CardOrganizer from './Components/CardOrganizer'
import PopupOrganizer from './Components/PopupOrganizer'
import FilterComponent from "../../components/FilterComponent/FilterComponent"
import InfiniteView from "../../components/InfiniteView";

import {getMeets, getMeetsFetching, getMeetsHasMore, getSingleMeet, getMeetsTime, getVenues} from "./reducer"

import {motion} from "framer-motion";
import {AnimatePresence} from "motion/react";

import {Dimmer, Dropdown, Loader} from "semantic-ui-react";
import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import {getSingleEvent} from "../Events/reducer";
import {getRolesAccess} from "../../components/Roles/Roles";

const Organizer = (props) => {
    const token = useSelector((state) => getAuthToken(state.userLogin))
    const dispatch = useDispatch()

    const userData = useSelector((state) => getUserData(state.userLogin));
    const roleAccess = getRolesAccess(userData.roles);

    if (!token) {
        return (
            <strong style={{margin: '0 0 0 50px'}}>Для получения доступа к списку, пожалуйста, авторизуйтесь</strong>
        )
    }


    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const [filterData, setFilterData] = useState({});
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    const [isPopupOpen, setIsPopupOpen] = useState(false)

    const meets = useSelector((state) => getMeets(state.meets)) || []
    const meetsTime = useSelector((state) => getMeetsTime(state.meets)) || []
    const venues = useSelector((state) => getVenues(state.meets)) || []
    const singleMeet = useSelector((state) => getSingleMeet(state.meets)) || {}
    const hasMore = useSelector((state) => getMeetsHasMore(state.meets))
    const fetching = useSelector((state) => getMeetsFetching(state.meets))

    const statusesOptions = [
        {
            text: t('meetingCanceled'),
            value: 'canceled',
        },
        {
            text: t('meetingCompleted'),
            value: 'completed',
        },
        {
            text: t('meetingDirected'),
            value: 'directed',
        },
        {
            text: t('meetingDeclined'),
            value: 'rejected',
        }
    ]

    const handleChangeStatuses = (e, {value}) => {
        setFilterData({
            ...filterData,
            statuses: value.join(','),
        })
        readMeets(1, {
            ...filterData,
            statuses: value.join(','),
        })
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if(!roleAccess.pageCounter || !token) {
            navigate('/')
        }
        if (token) readMeets(1, {})

    }, [])

    const readMeetsTime = () => {
        return new Promise((resolve, reject) => {
            dispatch(fetchTimeMeets(token, t))
                .then(response => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error);
                });
        })
    }

    const readVenues = () => {
        return new Promise((resolve, reject) => {
            dispatch(fetchVenues({}, t))
                .then(response => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error);
                })
        })
    }


    const readMeets = (page, params) => {
        return new Promise((resolve, reject) => {
            dispatch(fetchMeets(token, {
                lang: languageString,
                page: page,
                per_page: MEETS_PAGE_COUNT,
                order: 'asc',
                orderby: 'on_date',
                ...params
            }, t))
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };


    const handleOpenPopup = async (id) => {
        try {
            setIsPopupOpen(false);
            await readMeets(1, { id: id });
            await readMeetsTime();
            await readVenues();
            setIsPopupOpen(true);
        } catch (error) {
            console.error("Ошибка при загрузке данных:", error);
        }
    };

    const loadMeets = (page, params) => {
        const nextPage = Math.round(meets.length / MEETS_PAGE_COUNT) + 1
        readMeets(nextPage, filterData)
    }

    const handleChangeSearch = (e) => {
        const value = e.target.value;
        setFilterData({ ...filterData, search: value});
        if (value.length > 3) readMeets(1, { ...filterData, search: value});
        if (value.length === 0) readMeets(1, { ...filterData, search: value});
    };

    const MeetsList = ({ meets }) => {
        const list = meets.map((meet) => (
            <CardOrganizer
                key={meet.id}
                id={meet.id}
                initiator={{
                    initiator_user: meet.initiator_user,
                    initiator_user_name: meet.initiator_user_name,
                    initiator_user_name_en: meet.initiator_user_name_en,
                    initiator_exponent_name: meet.initiator_exponent_name,
                }}
                respondent={{
                    respondent_exponent: meet.respondent_exponent,
                    respondent_exponent_name: meet.respondent_exponent_name,
                    respondent_exponent_name_en: meet.respondent_exponent_name_en,
                    respondent_job_title: meet.respondent_job_title,
                    respondent_job_title_en: meet.respondent_job_title_en,
                    respondent_user: meet.respondent_user,
                    respondent_user_name: meet.respondent_user_name,
                    respondent_user_name_en: meet.respondent_user_name_en,
                }}
                meeting={{
                    meeting_status: meet.meeting_status,
                    meeting_status_name: meet.meeting_status_name,
                    meeting_status_name_en: meet.meeting_status_name_en,
                }}
                placement={meet.placement}
                on_date={meet.on_date}
                on_time={meet.on_time}
                expo_event={meet.expo_event}
                name={meet.name}
                onOpen={(id) => handleOpenPopup(id)}
            />
        ))
        return (
            <div className='organizer-grid'>
                {list}
            </div>
        )
    }

    return (
        <div className='organizer'>
            <h2 className='organizer-title'>{t('requestsMeeting')}</h2>
            <div className='organizer-header'>
                <FilterComponent
                    open={isFilterOpen}
                    onChange={() => setIsFilterOpen(!isFilterOpen)}
                />
                {
                    isFilterOpen && (
                        <AnimatePresence initial={false}>
                            <motion.div
                                className='organizer-filter-ctn'
                                initial={{maxHeight: 0, opacity: 0}}
                                animate={{maxHeight: 1000, opacity: 1, transition: {duration: 1}}}
                                exit={{maxHeight: 0, opacity: 0, transition: {duration: 0.4}}}
                            >
                                <div className='organizer-filter-field'>
                                    <label className='organizer-label'>{t('search')}</label>
                                    <input
                                        type="text"
                                        value={filterData.search}
                                        onChange={handleChangeSearch}
                                        className='cform-input'
                                        style={{height: '40px', padding: '5px 5px', maxWidth: '400px'}}
                                        placeholder={t('searchPlaceholder')}
                                    />
                                </div>
                                <div className='organizer-filter-field'>
                                    <label className='organizer-label'>{t('meetingStatus')}</label>
                                    <Dropdown
                                        fluid
                                        search
                                        scrolling
                                        selection
                                        multiple
                                        className='cform-drop filter-drop'
                                        options={statusesOptions}
                                        onChange={handleChangeStatuses}

                                    />
                                </div>

                            </motion.div>
                        </AnimatePresence>
                    )
                }
            </div>
            {
                meets && meets.length === 0 ? (
                    <div className='organizer-body' style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '300px',
                        textAlign: 'center'
                    }}>
                        <div style={{
                            padding: '20px',
                            fontSize: '25px',
                            color: '#666',
                            fontWeight: 'bold'
                        }}>
                            {t('noMeetsFound')}
                        </div>
                    </div>
                )
                :
                (
                    <>
                        <div className='organizer-body'>
                        <InfiniteView
                            dataLength={meets?.length}
                            nextFetch={loadMeets}
                            hasMore={hasMore}
                            mustAuth={true}
                            isAuth={!!token}
                            dataList={(
                                <MeetsList
                                    meets={Array.isArray(meets) ? meets : []}
                                />
                            )}

                        />
                        </div>
                        <PopupOrganizer
                            isOpen={isPopupOpen}
                            onClose={() => setIsPopupOpen(false)}
                            meet={singleMeet}
                            meetsTime={meetsTime}
                            venues={venues}
                            token={token}
                            readMeets={(page, params) => readMeets(page, params)}
                            filterData={filterData}
                            t={(key) => t(key)}
                        />
                    </>
                )
            }
            <Dimmer
                active={fetching}
                inverted
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}
            >
                <Loader size="large">{t('loadingEvents')}</Loader>
            </Dimmer>
        </div>
    )
}

export default Organizer;